import React from 'react';
import styles from './loading-screen.module.scss';

import ProgressSpinner from '@smart-tv/components/progress-spinner';

export const LoadingScreen = () => {
  //adding 700 milliseconds delay for loading screen
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(true);
    }, 700);
    return () => clearTimeout(timer);
  }, []);
  return (
    loading && (
      <div className={styles['loading-screen']}>
        <div className={styles['loading-screen__spinner']}>
          <ProgressSpinner />
        </div>
      </div>
    )
  );
};

export default LoadingScreen;
